import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import SignUpForm from './SignUpForm';

export default function SignUp() {
  const { t } = useTranslation();
  return (
    <>
      <Box
        bgcolor={'white'}
        borderRadius={'12px'}
        width={450}
        height={560}
        padding={'3rem 2rem'}
        display={'flex'}
        flexDirection={'column'}
        justifyContent={'space-between'}
      >
        <Typography variant="h5" fontWeight={'bold'} align="center">
          {t('Signup.label.signup')}
        </Typography>
        <br />
        <SignUpForm />
      </Box>
    </>
  );
}
